<template>
  <div class="content income-plan-list">
    <section style="margin-bottom: 1%">
      <a-button type="primary" @click="handleCreate">
        <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
        {{ $t('新增') }}
      </a-button>
    </section>

    <div class="form-content">
      <a-row :gutter="16" style="margin-top: 15px">
        <a-col :span="6">
          <CommonSelect
            :isBu="true"
            :list="$store.state.settlementBuList"
            :placeholder="$t('结算组织')"
            :code.sync="formData.businessUnitCode"
            @change="searchHandle(1)"
          />
        </a-col>
        <a-col :span="6">
          <a-input allow-clear v-model.trim="formData.planSn" :placeholder="$t('请输入计划编号')" />
        </a-col>
        <a-col :span="6">
          <a-select
            allow-clear
            v-model="formData.planType"
            :placeholder="$t('计划类型')"
            style="width: 100%"
          >
            <a-select-option v-for="(name, code) in mappings.planType" :key="code" :value="code">
              {{ name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.bizDocSn"
            :placeholder="$t('请输入业务单据编号')"
          />
        </a-col>
        <a-col :span="6">
          <a-select
            allow-clear
            v-model="formData.bizDocType"
            :placeholder="$t('业务单据类型')"
            style="width: 100%"
          >
            <a-select-option v-for="(name, code) in mappings.bizDocType" :key="code" :value="code">
              {{ name }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row :gutter="16" class="mt10">
        <a-col :span="6">
          <a-button @click="searchHandle(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t('查询') }}
          </a-button>
          <a-button @click="reset">
            <a-icon type="redo" />
            {{ $t('重置') }}
          </a-button>
        </a-col>
      </a-row>
    </div>

    <CommonTable
      ref="CommonTableRef"
      :statusList="income_plan_status"
      :showSelect="true"
      :selectedRowKeys.sync="selectedRowKeys"
      :selectedRows.sync="selectedRows"
      :scroll="{ x: 2900, y: scrollHeight }"
      :loading="tableLoading"
      :columns.sync="tableColumns"
      :data-source="tableData"
      :total="total"
      rowKey="id"
      @select="onSelectChange"
      @search="queryIncomePlanList"
    >
      <template v-slot:header>
        <a-button
          :disabled="selectedRowKeys.length === 0"
          :loading="operateLoading"
          @click="confirmOperate(operateType.SUBMIT)"
        >
          {{ $t('提交') }}
        </a-button>
        <a-button
          class="ml10"
          :disabled="selectedRowKeys.length === 0"
          :loading="operateLoading"
          @click="confirmOperate(operateType.CHECK)"
        >
          {{ $t('审核') }}
        </a-button>
        <a-button
          class="ml10"
          type="danger"
          :disabled="selectedRowKeys.length === 0"
          :loading="operateLoading"
          @click="confirmOperate(operateType.CANCEL)"
        >
          {{ $t('作废') }}
        </a-button>
        <IncomePlanPushBtn
          class="ml10"
          :pushList="pushPayload"
          :disabled="selectedRowKeys.length === 0"
          @success="searchHandle"
        />
      </template>

      <!-- 计划编号 -->
      <template v-slot:planSn="{ text, record }">
        <a @click="viewDetail(record)">{{ text }}</a>
      </template>
      <!-- 金额 -->
      <template v-slot:totalAmount="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
      <template v-slot:totalAmountWithoutTax="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
      <template v-slot:taxAmount="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
      <template v-slot:totalCost="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
      <template v-slot:confirmedAmount="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
      <template v-slot:confirmedCost="{ text, record }">
        <PriceInput :value="text" :showTxt="true" :currency="record.settlementCurrency" />
      </template>
    </CommonTable>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import IncomePlanPushBtn from '@component/incomePlanPushBtn'
import { convertKeysToCamelCase, fetchDocumentMappings } from '@/common'

// 提交/审核/作废的 operateType，与 operateDoc 的 action 保持一致
const OPERATE_TYPE = { SUBMIT: 'commit', CHECK: 'check', CANCEL: 'cancel' }
const OPERATE_RULE = {
  [OPERATE_TYPE.SUBMIT]: {
    statuses: ['DRAFT'],
    tip: '只有草稿状态的计划可以提交',
  },
  [OPERATE_TYPE.CHECK]: {
    statuses: ['WAIT_CHECK'],
    tip: '只有待审核状态的计划可以审核',
  },
  [OPERATE_TYPE.CANCEL]: {
    statuses: ['DRAFT', 'WAIT_CHECK'],
    tip: '只有草稿和待审核状态的计划可以作废',
  },
}

export default {
  name: 'incomePlanList',
  components: {
    IncomePlanPushBtn,
  },
  activated() {
    this.searchHandle()
    this.fetchMappings()
  },
  data() {
    return {
      docType: 'IncomePlan',
      operateType: OPERATE_TYPE,
      formData: {
        businessUnitCode: undefined,
        planSn: undefined,
        planType: undefined,
        bizDocSn: undefined,
        bizDocType: undefined,
        status: '',
      },
      mappings: {
        bizDocType: {},
        planType: {},
        allocationMethod: {},
      },
      tableLoading: false,
      operateLoading: false,
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      tableData: [],
    }
  },
  computed: {
    ...mapState(['income_plan_status']),
    ...mapGetters(['incomePlanStatusMapping']),
    scrollHeight() {
      return window.innerHeight - 470
    },
    // 列表下推：每张计划携带其全部分摊明细 id
    pushPayload() {
      return this.selectedRows.map((row) => ({
        planId: row.id,
        allocationIdList: this.getAllocationIds(row),
      }))
    },
    tableColumns() {
      return [
        {
          dataIndex: 'planSn',
          title: this.$t('计划编号'),
          width: 200,
          scopedSlots: { customRender: 'planSn' },
        },
        {
          title: this.$t('状态'),
          dataIndex: 'status',
          width: 110,
          customRender: (text) => this.incomePlanStatusMapping[text] || text,
        },
        {
          title: this.$t('计划类型'),
          dataIndex: 'planType',
          width: 130,
          customRender: (text) => this.mappings.planType[text] || text,
        },
        {
          title: this.$t('分摊方式'),
          dataIndex: 'allocationMethod',
          width: 120,
          customRender: (text) => this.mappings.allocationMethod[text] || '',
        },
        {
          title: this.$t('结算组织'),
          dataIndex: 'businessUnitName',
          width: 150,
        },
        {
          title: this.$t('业务单据类型'),
          dataIndex: 'bizDocType',
          width: 140,
          customRender: (text) => this.mappings.bizDocType[text] || text,
        },
        {
          title: this.$t('业务单据编号'),
          dataIndex: 'bizDocSn',
          width: 180,
        },
        {
          title: this.$t('开始日期'),
          dataIndex: 'startDate',
          width: 120,
          customRender: (text) => (text ? String(text).split(' ')[0] : ''),
        },
        {
          title: this.$t('结束日期'),
          dataIndex: 'endDate',
          width: 120,
          customRender: (text) => (text ? String(text).split(' ')[0] : ''),
        },
        {
          title: this.$t('结算货币'),
          dataIndex: 'settlementCurrency',
          width: 100,
        },
        {
          title: this.$t('本位币'),
          dataIndex: 'functionalCurrency',
          width: 100,
        },
        {
          title: this.$t('总金额'),
          dataIndex: 'totalAmount',
          width: 130,
          scopedSlots: { customRender: 'totalAmount' },
        },
        {
          title: this.$t('未税金额'),
          dataIndex: 'totalAmountWithoutTax',
          width: 130,
          scopedSlots: { customRender: 'totalAmountWithoutTax' },
        },
        {
          title: this.$t('税额'),
          dataIndex: 'taxAmount',
          width: 120,
          scopedSlots: { customRender: 'taxAmount' },
        },
        {
          title: this.$t('总成本'),
          dataIndex: 'totalCost',
          width: 120,
          scopedSlots: { customRender: 'totalCost' },
        },
        {
          title: this.$t('已确认金额'),
          dataIndex: 'confirmedAmount',
          width: 130,
          scopedSlots: { customRender: 'confirmedAmount' },
        },
        {
          title: this.$t('已确认成本'),
          dataIndex: 'confirmedCost',
          width: 130,
          scopedSlots: { customRender: 'confirmedCost' },
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
          width: 160,
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createdAt',
          width: 180,
        },
        {
          title: this.$t('创建人'),
          dataIndex: 'createdUser',
          width: 120,
        },
        {
          title: this.$t('更新时间'),
          dataIndex: 'updatedAt',
          width: 180,
        },
        {
          title: this.$t('更新人'),
          dataIndex: 'updatedUser',
          width: 120,
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    handleCreate() {
      this.addPane({
        view: 'receivableManage/incomePlanDetail',
        name: 'detailSn',
        route: '/receivableManage/incomePlanDetail',
      })
    },
    viewDetail(record) {
      this.addPane({
        view: 'receivableManage/incomePlanDetail/' + record.planSn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.planSn,
        },
        route: `/receivableManage/incomePlanDetail?id=${record.id}&sn=${record.planSn}`,
      })
    },
    reset() {
      const mappings = this.mappings
      Object.assign(this.$data, this.$options.data.call(this))
      this.mappings = mappings
      this.searchHandle(1)
    },
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, [
        'bizDocType',
        'planType',
        'allocationMethod',
      ])
    },
    searchHandle(pageNo) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    getAllocationIds(row) {
      const ids = []
      ;(row.detailList || []).forEach((detail) => {
        ;(detail.allocationList || []).forEach((allocation) => {
          if (allocation.id) ids.push(allocation.id)
        })
      })
      return ids
    },
    async queryIncomePlanList(params = {}) {
      const pageNo = params.page_no || 1
      const pageSize = params.page_size || 20
      this.tableLoading = true
      try {
        const res = await http({
          type: 'post',
          url: api.getIncomePlanList,
          data: {
            bizDocSn: this.formData.bizDocSn || '',
            bizDocType: this.formData.bizDocType || '',
            businessUnitCode: this.formData.businessUnitCode || '',
            planSn: this.formData.planSn || '',
            planType: this.formData.planType || '',
            status: params.status || '',
            pageNo,
            pageSize,
            // 兼容后端 snake_case 分页参数
            page_no: pageNo,
            page_size: pageSize,
          },
        })
        this.tableData = convertKeysToCamelCase(res.result?.list || [])
        this.total = res.result?.total || 0
      } finally {
        this.tableLoading = false
      }
    },
    confirmOperate(operateType) {
      const rule = OPERATE_RULE[operateType] || {}
      const invalidRows = this.selectedRows.filter(
        (row) => !(rule.statuses || []).includes(row.status)
      )
      if (invalidRows.length > 0) {
        this.$message.warning(this.$t(rule.tip || '当前单据状态不支持该操作'))
        return
      }
      const textMap = {
        [OPERATE_TYPE.SUBMIT]: this.$t('提交'),
        [OPERATE_TYPE.CHECK]: this.$t('审核'),
        [OPERATE_TYPE.CANCEL]: this.$t('作废'),
      }
      this.$confirm({
        title: this.$t('确认操作'),
        content: `${this.$t('是否确认')}${textMap[operateType] || ''}${this.$t('已选中的')} ${
          this.selectedRowKeys.length
        } ${this.$t('个计划')}？`,
        onOk: () => this.batchOperate(operateType),
      })
    },
    async batchOperate(operateType) {
      this.operateLoading = true
      try {
        const results = await Promise.allSettled(
          this.selectedRowKeys.map((id) =>
            http({
              url: api.operateIncomePlan,
              type: 'post',
              data: { id, operateType },
              fail: () => {},
            })
          )
        )
        const failCount = results.filter((item) => item.status === 'rejected').length
        if (failCount > 0) {
          this.$warning({
            title: this.$t('提示'),
            content: `${this.$t('失败')} ${failCount} ${this.$t('条')}`,
          })
        } else {
          this.$success({
            title: this.$t('成功'),
            content: this.$t('操作成功'),
          })
        }
      } finally {
        this.operateLoading = false
        this.searchHandle()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
</style>
